// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GDzE6","image":"Header_image__31lvR","name":"Header_name__1NFlg","info":"Header_info__ALgDI","infoRow":"Header_infoRow__aCdVH"};